import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "35",
  height: "35",
  viewBox: "0 0 35 35",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "mask0_1704_6587",
      style: {"mask-type":"alpha"},
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "35",
      height: "35"
    }, [
      _createElementVNode("rect", {
        x: "0.152344",
        width: "34.6963",
        height: "34.6963",
        fill: "#D9D9D9"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#mask0_1704_6587)" }, [
      _createElementVNode("path", {
        d: "M5.9353 31.8049C5.14018 31.8049 4.45975 31.5221 3.894 30.9563C3.3273 30.3896 3.04395 29.7087 3.04395 28.9136V13.0111C3.04395 12.216 3.3273 11.5351 3.894 10.9684C4.45975 10.4026 5.14018 10.1198 5.9353 10.1198H13.1637V5.78271C13.1637 4.98759 13.4471 4.30668 14.0138 3.73997C14.5795 3.17423 15.2599 2.89136 16.0551 2.89136H18.9464C19.7415 2.89136 20.4224 3.17423 20.9892 3.73997C21.5549 4.30668 21.8378 4.98759 21.8378 5.78271V10.1198H29.0662C29.8613 10.1198 30.5422 10.4026 31.1089 10.9684C31.6746 11.5351 31.9575 12.216 31.9575 13.0111V28.9136C31.9575 29.7087 31.6746 30.3896 31.1089 30.9563C30.5422 31.5221 29.8613 31.8049 29.0662 31.8049H5.9353ZM5.9353 28.9136H29.0662V13.0111H21.8378C21.8378 13.8062 21.5549 14.4867 20.9892 15.0524C20.4224 15.6191 19.7415 15.9025 18.9464 15.9025H16.0551C15.2599 15.9025 14.5795 15.6191 14.0138 15.0524C13.4471 14.4867 13.1637 13.8062 13.1637 13.0111H5.9353V28.9136ZM8.82666 26.0222H17.5007V25.3717C17.5007 24.9621 17.386 24.5823 17.1567 24.2325C16.9282 23.8836 16.6092 23.6128 16.1996 23.42C15.7177 23.2031 15.2301 23.0407 14.7366 22.9328C14.2422 22.8239 13.7179 22.7694 13.1637 22.7694C12.6095 22.7694 12.0857 22.8239 11.5922 22.9328C11.0978 23.0407 10.6097 23.2031 10.1278 23.42C9.71816 23.6128 9.39915 23.8836 9.17073 24.2325C8.94135 24.5823 8.82666 24.9621 8.82666 25.3717V26.0222ZM20.3921 23.8537H26.1748V21.6852H20.3921V23.8537ZM13.1637 21.6852C13.7661 21.6852 14.2778 21.4741 14.699 21.052C15.1211 20.6308 15.3322 20.119 15.3322 19.5167C15.3322 18.9143 15.1211 18.4025 14.699 17.9814C14.2778 17.5592 13.7661 17.3481 13.1637 17.3481C12.5613 17.3481 12.0496 17.5592 11.6284 17.9814C11.2062 18.4025 10.9952 18.9143 10.9952 19.5167C10.9952 20.119 11.2062 20.6308 11.6284 21.052C12.0496 21.4741 12.5613 21.6852 13.1637 21.6852ZM20.3921 19.5167H26.1748V17.3481H20.3921V19.5167ZM16.0551 13.0111H18.9464V5.78271H16.0551V13.0111Z",
        fill: "var(--fill-color, #353535)"
      })
    ], -1)
  ])))
}
export default { render: render }